function DefaultAlert (text) {
    if (!window.Swal) {
        throw 'Swal dependency not found'
    }

    this.text = text
}

DefaultAlert.prototype.show = function (config = {}) {
    return Swal.fire({
        animation: false,
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-primary',
        },
        html: this.text,
        ...config
    }).then(result => {
        return result.value;
    })
}

export default DefaultAlert
